module.exports = __webpack_public_path__ + "static/media/user_icon.7db2b28f.svg";